import { useCallback } from 'react';
import { useEmbedFeedStoreApi } from '@core/widgets/embedFeed/store';
import { useStoreApi } from '@core/widgets/store';
import { filterCurrentInViewport, sortByOtherArray } from '@embed/tools/utils';
/**
 * Hook to provide a callback to lazy resolve current
 * in-viewport video thumbnail ids from widget store
 * and embed feed store via api's. Uses `navigation` list
 * of video ids from widget store to sort in-viewport ids.
 */
export function useInViewportIds() {
    const storeApi = useStoreApi();
    const embedFeedStoreApi = useEmbedFeedStoreApi();
    return useCallback(() => {
        const navigation = storeApi.getState().navigation;
        const inViewportIds = embedFeedStoreApi.getState().inViewportIds;
        const inViewportIdsFiltered = filterCurrentInViewport(inViewportIds);
        const inViewportIdsSorted = sortByOtherArray(inViewportIdsFiltered, navigation);
        return inViewportIdsSorted;
    }, [embedFeedStoreApi, storeApi]);
}
